import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { IWidgetItem } from '../../interfaces/widget-item.interface';
import { Widget } from '../../decorator/widget.decorator';
import { IdynamicFormItem } from '../../../../app/shared/dynamic-form/interfaces/IdynamicFormItem';
import { get } from 'lodash';

@Component({
  selector: 'ispm-rich-notes-widget',
  templateUrl: './rich-notes-widget.component.html',
  styleUrls: ['./rich-notes-widget.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
@Widget()
export class RichNotesWidgetComponent implements OnInit, IWidgetItem {
  public data = { };

  public formConfig: Array<IdynamicFormItem> = [];

  set widgetConfig(widgetConfig: IdynamicFormItem) {
    const widgetPayload = get(widgetConfig, 'widgetPayload', { });
    Object.assign(this, widgetPayload);
    this.formConfig = widgetPayload.formConfig;
  }

  set widgetData(widgetData: any) {
    this.data = widgetData || { };
  }

  widgetUpdateValueCallback: (value) => void;

  constructor() {
  }

  ngOnInit() {
  }

  notesChanged($event) {

    this.widgetUpdateValueCallback($event);
  }


}
